import { UsersApi } from "@simbelapp/order-sdk";
import { useSDKApi } from "~/composables/api/useSDKApi";
import { MicroserviceEnum } from "~/utils/enums/common.enums";

/**
 * Lazy-load source shared by every collaborator dropdown.
 *
 * Hits `/users/company-users` so the pages it appends into `usersStore.companyUsers` carry the same
 * `UserCompanyModel` shape the store's initial fetch puts there. The dropdown pushes into that one
 * array, so a mismatch between seed and lazy pages blanks out the options mid-scroll.
 */
export const useCompanyUsersDropdown = () => {
  async function companyUsersServicesAPI(params: Record<string, unknown>) {
    const apiInstance = await useSDKApi(MicroserviceEnum.ORDERS, UsersApi);

    return await apiInstance.getUsersCompany({ lazyLoad: true, enableRolesFilters: false, ...params });
  }

  return { companyUsersServicesAPI };
};
